import React from 'react';

import { AuthLogout } from '@klpkonsern/auth-core/routes';
import { Typography } from '@klp/design';
import { Main } from '@klp/layout';

export const LogoutView: React.FC = () => {
    const clearAppData = async () => {
        try {
            // Clear any application-specific data here if needed
            sessionStorage.clear();
            localStorage.removeItem('selectedClient');
        } catch (error) {
            console.error('Error clearing application data:', error);
        }
    };

    return (
        <AuthLogout onLogout={clearAppData}>
            <Main
                withoutHeader={true}
                withoutSidebar={true}
                centered={true}
                fullScreen={true}
            >
                <Typography
                    klpHeadingLevel="ONE"
                    translation="auth.loggingOut"
                />
            </Main>
        </AuthLogout>
    );
};
